<template>
  <div class="IConfirm">
    <div class="IConfirmBox">
      <div class="tw-font-bold tw-text-lg tw-leading-snug tw-mb-4">
        {{ title }}
      </div>

      <div class="tw-flex tw-gap-2">
        <i-button
          class="tw-px-10 tw-flex-1"
          @click="doCancel"
        >
          {{ cancelButtonText }}
        </i-button>
        <i-button
          type="primary"
          class="tw-px-10 tw-flex-1"
          @click="doConfirm"
        >
          {{ confirmButtonText }}
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },

    cancelButtonText: {
      type: String,
      default: 'Cancel',
    },

    confirmButtonText: {
      type: String,
      default: 'Confirm',
    },

    doConfirm: {
      type: Function,
      default: () => {},
    },

    doCancel: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.IConfirm {
  @apply tw-fixed tw-top-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full;
  @apply tw-bg-gray-dark tw-bg-opacity-80 dark:tw-bg-dm-gray dark:tw-bg-opacity-80;

  z-index: 3000;
}

.IConfirmBox {
  @apply tw-border-none tw-bg-white tw-rounded-3xl tw-text-dark tw-shadow tw-p-6 tw-max-w-sm;
  @apply dark:tw-bg-dm-light dark:tw-text-dm-dark;
}
</style>
